var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "point-layer-trigger" }, [_c('pt-button', { ref: "trigger", attrs: { "type": "outlined", "theme": "primary", "mini": "" }, on: { "click": _vm.handleClick } }, [_vm._v("\n    " + _vm._s(_vm.btnLabel) + "\n  ")]), _vm._v(" "), _c('point-dialog', { ref: "pointDialogRef", attrs: { "visible": _vm.dialogVisible }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, [_c('point-list', { attrs: { "list": _vm.innerPointList, "actions": _vm.actions } })], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };